import React from 'react'
import { Card, CardContent, Typography, Box } from '@mui/material'
import DateRangeFilter from '../../../../components/DateRangeFilter'
import { isSameDateRange } from '../../helpers/dateRangeUtils'

const OcDateRangeCard = ({
  value,
  onChange,
  defaultDates,
  onResetAll,
  disabled = false,
  title = 'Periodo de búsqueda',
  cardSx = {},
  contentSx = {},
  titleSx = {},
  actionsSx = {},
  containerSx = {}
}) => {
  const isDefaultRange = isSameDateRange(value, defaultDates)

  return (
    <Card elevation={0} className="oc-date-range-card" sx={cardSx}>
      <CardContent className="oc-date-range-card-content" sx={contentSx}>
        <Box display="flex" justifyContent="space-between" alignItems="center" sx={containerSx}>
          <Typography className="oc-date-range-title" sx={titleSx}>
            {title}
          </Typography>

          <Box className="oc-date-range-actions" sx={actionsSx}>
            <Typography sx={{ mt: 1 }} variant="body2">
              Rango de fechas:
            </Typography>

            <Box className="oc-date-range-filter">
              <DateRangeFilter
                disabled={disabled}
                value={value}
                onChange={onChange}
              />
            </Box>

            {!isDefaultRange && (
              <Typography
                variant="body2"
                className="oc-date-range-reset"
                onClick={onResetAll}
              >
                Restablecer
              </Typography>
            )}
          </Box>
        </Box>
      </CardContent>
    </Card>
  )
}

export default OcDateRangeCard
